import { connect } from 'react-redux';

import OrgInfoPage from './OrgInfoPage';
import { actionCreators as orgActionCreators } from '../../../dux/org';
import { actionCreators as userActionCreators, selectors } from '../../../dux/user';

const mapDispatchToProps = {
  handleUpdateSession: userActionCreators.updateSession,
  handleOrgCreate: orgActionCreators.createOrg,
};

const mapStateToProps = (state) => ({
  user: selectors.getUserState(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrgInfoPage);
